import { styled } from 'styled-components';

export const BorderBoxInput = ({
  border,
  setBorder,
}: {
  border: 'Top' | 'Right' | 'Bottom' | 'Left' | 'All';
  setBorder: (border: 'Top' | 'Right' | 'Bottom' | 'Left' | 'All') => void;
}) => {
  return (
    <Container>
      <Box>
        {border !== 'All' && <Square onClick={() => setBorder('All')} />}
        {border === 'All' && <span key="All">All</span>}

        <BoxBorder
          $active={border === 'All' || border === 'Top'}
          $top
          onClick={() => setBorder('Top')}
        />
        <BoxBorder
          $active={border === 'All' || border === 'Right'}
          $right
          onClick={() => setBorder('Right')}
        />
        <BoxBorder
          $active={border === 'All' || border === 'Bottom'}
          $bottom
          onClick={() => setBorder('Bottom')}
        />
        <BoxBorder
          $active={border === 'All' || border === 'Left'}
          $left
          onClick={() => setBorder('Left')}
        />
      </Box>
    </Container>
  );
};

const Container = styled.div`
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Box = styled.div`
  position: relative;
  width: 70px;
  height: 70px;
  border: 1px solid var(--input-border-color);

  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 12px;
  font-weight: 300;
  color: var(--accent-color);
`;

const Square = styled.div`
  position: absolute;
  width: 20px;
  height: 20px;

  border: 1px solid var(--input-border-color);
  background-color: var(--panel-bg-color);

  transition:
    border 0.3s ease,
    background-color 0.3s ease;

  &:hover {
    border: 1px solid var(--text-color);
    background-color: var(--panel-bg-color-hover);
  }
`;

const BoxBorder = styled.div<{
  $active?: boolean;
  $top?: boolean;
  $right?: boolean;
  $bottom?: boolean;
  $left?: boolean;
}>`
  position: absolute;
  width: 100%;
  height: 15px;

  display: flex;
  align-items: center;

  &:hover {
    &:after {
      background-color: var(--text-color);
    }
  }

  &:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 2px;

    transition: background-color 0.3s ease;
  }

  ${({ $active }) =>
    $active && `&:after { background-color: var(--accent-color); }`}

  ${({ $top }) => $top && `top: 0; transform: translateY(-50%);`}
  ${({ $right }) =>
    $right && `right: 0; transform: translateX(50%) rotate(90deg);`}
  ${({ $bottom }) => $bottom && `bottom: 0; transform: translateY(50%);`}
  ${({ $left }) =>
    $left && `left: 0; transform: translateX(-50%) rotate(-90deg);`}
`;
